import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";
import { SubTitle, Text } from "utils/styling/typography.styled";

export const Container = styled.main`
    gap: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-self: center;
    width: 100%;
    padding: 2rem;
    padding-top: 5rem;

    ${device.lg} {
        width: 75%;
    }
    ${device.xl} {
        width: 60%;
    }
`;

export const Header = styled.header`
    text-align: center;
    margin-bottom: 2rem;
`;

export const FaqSection = styled.section`
    margin-top: 2rem;
`;

export const FaqTitle = styled(SubTitle)`
    margin-bottom: 1rem;
`;

export const Faq = styled.div`
    margin-bottom: 1rem;
`;

export const Question = styled.h3`
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
`;

export const Answer = styled(Text)`
    line-height: 1.5;
`;

export const Section = styled.section`
    margin-bottom: 3rem;
`;

export const SectionTitle = styled.h2`
    font-size: 2rem;
    color: ${colourScheme.alert};
    margin-bottom: 1rem;
`;

export const Loading = styled.div`
    text-align: center;
    font-size: 1.5rem;
    color: ${colourScheme.primary};
`;

export const Error = styled.div`
    text-align: center;
    font-size: 1.5rem;
    color: ${colourScheme.alert};
`;
